import { render, staticRenderFns } from "./AnexosRecomendacion.vue?vue&type=template&id=492d4246&scoped=true"
import script from "./AnexosRecomendacion.vue?vue&type=script&lang=js"
export * from "./AnexosRecomendacion.vue?vue&type=script&lang=js"
import style0 from "./AnexosRecomendacion.vue?vue&type=style&index=0&id=492d4246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d4246",
  null
  
)

export default component.exports